/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { GetStudentMcqAnswers } from "../api/Quiz/McqTrialAnswers";
import { useUserDataStore } from "../stores/user";
import StudentAnswers from "../components/Quiz/StudentAnswers";
import Spinner from "../components/Shared/Spinner";

const QuizAnswers = () => {
  const { userData } = useUserDataStore();
  const studentId = userData?.id || "";
  const { quizId, num_trial } = useParams<{
    quizId: string;
    num_trial: string;
  }>();

  const quizIdString = quizId || "";
  const numTrialNumber = num_trial ? parseInt(num_trial) : 0;

  const { data: AnswersDTO, isLoading } = useQuery({
    queryFn: () =>
      GetStudentMcqAnswers(quizIdString, studentId, numTrialNumber),
    queryKey: ["studentAnswers", quizIdString, studentId, numTrialNumber],
    staleTime: 0,
    refetchInterval: 0,
    enabled: !!quizId && !!num_trial,
  });

  const answers = AnswersDTO?.data;
  if (isLoading)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner />
      </div>
    );
  return (
    <div className="min-h-screen  pt-20">
      {/* @ts-expect-error */}
      <StudentAnswers submissionResponse={answers} />
    </div>
  );
};

export default QuizAnswers;
